import React, { useState } from 'react'
import { Button, Dropdown, Form, Modal } from 'react-bootstrap'
import {
  CreateVacancyCompany,
  IVacancyCompany,
  VacancyCompanyHook
} from "../../../api/vacancy-company/vacancy-company.api";
import {toast} from "react-toastify";
import {ERROR_MESSAGES, getErrorMessage} from "../../../api/error-messages";
import ReactInputMask from "react-input-mask";

type Props = {
  vacancyCompany?: IVacancyCompany
  isCreate?: boolean
  update:() => void
  companyId: string | number
}

export const EditVacancyCompany = ({vacancyCompany, update, isCreate = false, companyId}: Props) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  }
  const { mutate: EditMutate } = VacancyCompanyHook.useUpdateVacancyCompany()
  const { mutate: CreateMutate } = VacancyCompanyHook.useCreateVacancyCompany()
  const baseValue = isCreate ? new CreateVacancyCompany() : {...new CreateVacancyCompany(), ...vacancyCompany}
  const [formValues, setFormValue] = useState<CreateVacancyCompany>(baseValue)
  const handleForm = (e: React.FormEvent) => {
    e.preventDefault();

    if (isCreate) {
      CreateMutate({...formValues, companyId}, {
        onSuccess: () => {
          toast.success("Заказчик успешно создан!");
          update()
          handleClose();
        },
        onError: (error: any) => {
          toast.error(getErrorMessage(error));
        },
      });
      return
    }
    EditMutate({...formValues, companyId}, {
      onSuccess: () => {
        toast.success("Заказчик успешно обновлен!");
        update()
        handleClose();
      },
      onError: (error) => {
        toast.error(getErrorMessage(error));
      },
    });
  }


  return <>
  {isCreate
    ? (
      <Button className={'w-fit'} variant="primary" onClick={handleShow}>
        Ручная регистрация заказчика
      </Button>
    )
    : (
    <Dropdown.Item onClick={handleShow} >
      Редактировать
    </Dropdown.Item>
    )
  }


    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Редактирование заказчика</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>

          <Form.Group controlId='bin' className='mb-3'>
            <Form.Label>*БИН</Form.Label>
            <Form.Control value={formValues.bin}
                          as={ReactInputMask}
                          mask="999999999999"
                          required onChange={(e)=>setFormValue((prev)=>({...prev,bin:e.target.value}))} />
          </Form.Group>

          <Form.Group controlId='lawName' className='mb-3'>
            <Form.Label>*Юридическое имя</Form.Label>
            <Form.Control required value={formValues?.lawName}
                          onChange={e => setFormValue((prev) => {
                            return { ...prev, lawName: e.target.value }
                          })} />
          </Form.Group>

          <Form.Group controlId='name' className='mb-3'>
            <Form.Label>*Отображаемое в системе имя</Form.Label>
            <Form.Control required value={formValues?.name} onChange={e => setFormValue((prev) => {
              return { ...prev, name: e.target.value }
            })} />
          </Form.Group>

          <Form.Group controlId='description' className='mb-3'>
            <Form.Label>Краткое описание</Form.Label>
            <Form.Control value={formValues?.description} onChange={e => setFormValue((prev) => {
              return { ...prev, description: e.target.value }
            })} />
          </Form.Group>

          <Form.Group controlId='code' className='mb-3'>
            <Form.Label>Код</Form.Label>
            <Form.Control value={formValues?.code} onChange={e => setFormValue((prev) => {
              return { ...prev, code: e.target.value }
            })} />
          </Form.Group>

          <Form.Group controlId='address' className='mb-3'>
            <Form.Label>*Адрес расположения компании (если нет, то адрес регистрации юридического лица)</Form.Label>
            <Form.Control required value={formValues?.address} onChange={e => setFormValue((prev) => {
              return { ...prev, address: e.target.value }
            })} />
          </Form.Group>

          <Form.Group controlId='phone' className='mb-3'>
            <Form.Label>*Телефон (ответственного лица по вопросам партнерства)</Form.Label>
            <Form.Control required value={formValues?.phone}
                          as={ReactInputMask}
                          mask={"+7 999 999 9999"}
                          onChange={e => setFormValue((prev) => {
                            return { ...prev, phone: e.target.value }
                          })} />
          </Form.Group>

          <Button onClick={handleForm} variant="primary" type="submit">Сохранить изменения</Button>
        </Form>
      </Modal.Body>

    </Modal>
  </>
}